module.exports = __webpack_public_path__ + "static/media/camera.701b1722.svg";